/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const RESERVE_COUNTER = (counter) => {
    return (
        <FormattedMessage
            id='reserve_tooltip.counter'
            defaultMessage={'{counter} на складе'}
            values={{
                counter,
            }}
        />
    )
}

export const RESERVE_BUILDING = (buildingName) => {
    return (
        <FormattedMessage
            id='reserve_tooltip.building'
            defaultMessage={'Подготавливается в строении {buildingName}'}
            values={{ buildingName }}
        />
    )
}

export const ACTIVATABLE_IN_BATTLE_ROOM_DOES_NOT_HAVE_PERMISSION = (
    <FormattedMessage
        id='reserve_tooltip.activatable_in_battle_room_does_not_have_permission'
        defaultMessage={'Устанавливается командиром отряда с должностью командующего, заместителя командующего, офицера штаба или командира подразделения'} // eslint-disable-line max-len
    />
)

export const ACTIVATABLE_IN_BATTLE_ROOM_INSTALL_IS_NOT_POSSIBLE = (
    <FormattedMessage
        id='reserve_tooltip.activatable_in_battle_room_install_is_not_possible'
        defaultMessage={'Установка недоступна.'}
    />
)

export const ACTIVATABLE_IN_BATTLE_ROOM_RESERVE_DOES_NOT_EXIST = (
    <FormattedMessage
        id='reserve_tooltip.activatable_in_battle_room_reserve_does_not_exist'
        defaultMessage={'Резерва нет на складе'}
    />
)

export const ACTIVATABLE_IN_BATTLE_ROOM_READY_TO_INSTALL = (
    <FormattedMessage
        id='reserve_tooltip.activatable_in_battle_room_ready_to_install'
        defaultMessage={'Готов к установке в окне отряда'}
    />
)

export const RESERVE_IS_ACTIVATED = (time) => {
    return (
        <FormattedMessage
            id='reserve_tooltip.reserve_is_activated'
            defaultMessage={'Активирован. Действует в течение {time}'}
            values={{ time }}
        />
    )
}

export const DOES_NOT_HAVE_PERMISSION = (
    <FormattedMessage
        id='reserve_tooltip.does_not_have_permission'
        defaultMessage={'Активируется командующим, заместителем командующего, офицером штаба или командиром подразделения'}  // eslint-disable-line max-len
    />
)

export const ACTIVATION_IS_IMPOSSIBLE = (
    <FormattedMessage
        id='reserve_tooltip.activation_is_impossible'
        defaultMessage={'Активация невозможна.'}
    />
)

export const ANOTHER_RESERVE_IS_ACTIVATED = (
    <FormattedMessage
        id='reserve_tooltip.another_reserve_is_activated'
        defaultMessage={'Ожидайте завершения действия другого резерва из этой группы'}
    />
)

export const RESERVE_DOES_NOT_EXIST = (
    <FormattedMessage
        id='reserve_tooltip.reserve_does_not_exist'
        defaultMessage={'Резерва нет на складе'}
    />
)

export const READY_FOR_ACTIVATION = (
    <FormattedMessage
        id='reserve_tooltip.ready_for_activation'
        defaultMessage={'Готов к активации'}
    />
)

export const X_LEVEL_ONLY = (
    <FormattedMessage
        id='reserve_tooltip.x_level_only'
        defaultMessage={'Only for Tier X-XI vehicles'}
    />
)

export const FROM_CHALLENGES = (
    <FormattedMessage
        id='reserve_tooltip.from_challenges'
        defaultMessage={'Можно получить наградой в Военных играх'}
    />
)

export const EARN_LACKING_INDUSTRIAL_RESOURCE = (
    <FormattedMessage
        id='reserve_tooltip.activation_id_frozen'
        defaultMessage={'Заработайте недостающий промресурс, чтобы погасить штраф.'}
    />
)

export const RESERVIST_DOESNT_RECEIVE_BONUS = (
    <FormattedMessage
        id='reserve_tooltip.reservist_doesnt_receive'
        defaultMessage={'Резервисты не получают надбавок от клановых резервов.'}
    />
)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveTooltip/constants.jsx